export {default} from './Input';
export type {IInputProps} from './Input';
export {INPUT_PADDING, INPUT_HEIGHT} from './Input.style';
